import { OptionType } from 'components/UI/SelectField';
import {
  Acceptor,
  Annotator,
  Authorizer,
  Validator,
  Service,
  NON_CFS,
  CFS,
  TRUSTED_CFS,
  BasicData,
  ADAPTER,
  BIGDATA_INTEGRATION,
  Divert,
  Address,
} from 'models/husqiotbus';

export const requestResponse = 'request-response';
export const unsolicited = 'unsolicited';

export const divertTypeOptions: OptionType[] = [
  {
    key: 'reqrep',
    label: requestResponse,
    value: requestResponse,
  },
  {
    key: unsolicited,
    label: unsolicited,
    value: unsolicited,
  },
];

export function getDefaultForServiceType(
  serviceType?: string,
  basicData?: BasicData,
  serviceName?: string
): Service {
  let annotators: Annotator[] = [];
  let authorizers: Authorizer[] = [];
  let validators: Validator[] = [];
  let acceptors: Acceptor[] = [];
  let diverts: Divert[] = [];
  let addresses: Address[] = [];
  if (basicData) {
    annotators = basicData.annotators.map((a) => {
      return { name: a.name, checked: false, disabled: false };
    });
    authorizers = basicData.authorizers.map((a) => {
      return { name: a.name, checked: false, disabled: false };
    });
    validators = basicData.validators.map((v) => {
      return { name: v.name, checked: false, disabled: false };
    });
    acceptors = basicData.acceptors.map((a) => {
      return { name: a.name, checked: false, disabled: false };
    });
    addresses = basicData.addresses.map((a) => {
      return {
        name: a.name,
        checked: false,
        disabled: false,
      };
    });
  }

  if (serviceType === CFS) {
    annotators = annotators.map((a) => {
      if (a.name === 'rejectable') {
        a.checked = true;
        a.disabled = true;
        return a;
      }
      return a;
    });
    acceptors = acceptors.map((a) => {
      if (
        ['authorized', 'well-known', 'authorization', 'subscription'].includes(
          a.name
        )
      ) {
        a.checked = true;
        a.disabled = true;
        return a;
      }
      return a;
    });
    validators = validators.map((v) => {
      if (['opExists', 'serviceIsConnectivityApi'].includes(v.name)) {
        v.checked = true;
        v.disabled = true;
        return v;
      }
      return v;
    });
    diverts = getDefaultDiverts(serviceName);
  } else if (
    serviceType === NON_CFS ||
    serviceType === ADAPTER ||
    serviceType === BIGDATA_INTEGRATION
  ) {
    acceptors = acceptors.map((a) => {
      if (['acceptAny'].includes(a.name)) {
        a.checked = true;
        a.disabled = false;
        return a;
      }
      return a;
    });
  } else if (serviceType === TRUSTED_CFS) {
    annotators = annotators.map((a) => {
      if (a.name === 'rejectable') {
        a.checked = true;
        a.disabled = true;
        return a;
      }
      return a;
    });
    acceptors = acceptors.map((a) => {
      if (['well-known'].includes(a.name)) {
        a.checked = true;
        a.disabled = true;
        return a;
      }
      return a;
    });
    validators = validators.map((v) => {
      if (['opExists', 'serviceIsConnectivityApi'].includes(v.name)) {
        v.checked = true;
        v.disabled = true;
        return v;
      }
      return v;
    });
    diverts = getDefaultDiverts(serviceName);
  }
  addresses = getDefaultAddresses(addresses, serviceType);
  const service = {
    type: serviceType || '',
    annotators,
    acceptors,
    authorizers,
    validators,
    name: '',
    diamServiceName: '',
    diverts,
    addresses,
    existingDiverts: [],
  };
  return service;
}

function getDefaultDiverts(serviceName?: string): Divert[] {
  return [
    {
      serviceName: 'connectivity-api',
      type: 'request-response',
      filter: `(&quot;op&quot; IS NOT NULL) AND (&quot;responseCode&quot; IS NOT NULL) AND (&quot;correlationId&quot; LIKE 'iot.${serviceName}:%') AND (&quot;service&quot; = 'connectivity-api')`,
      environments: ['dev', 'qa', 'live'],
      version: '',
    },
    {
      serviceName: 'connectivity-api',
      type: 'unsolicited',
      filter: '(&quot;op&quot; IS NULL)',
      environments: ['dev', 'qa', 'live'],
      version: '',
    },
  ];
}

function getDefaultAddresses(
  addresses: Address[],
  serviceType?: string
): Address[] {
  if (serviceType === ADAPTER) {
    addresses.find((a) => a.name === 'out')!.checked = true;
    addresses.find((a) => a.name === 'response.in')!.checked = true;
    addresses.find((a) => a.name === 'request.in')!.checked = true;
  }
  if (serviceType === BIGDATA_INTEGRATION) {
    addresses.find((a) => a.name === 'unsolicited.in')!.checked = true;
  }
  if (serviceType === CFS) {
    addresses.find((a) => a.name === 'out')!.checked = true;
    addresses.find((a) => a.name === 'response.in')!.checked = true;
    addresses.find((a) => a.name === 'unsolicited.in')!.checked = true;
  }
  if (serviceType === NON_CFS) {
    addresses.find((a) => a.name === 'out')!.checked = true;
    addresses.find((a) => a.name === 'response.in')!.checked = true;
    addresses.find((a) => a.name === 'request.in')!.checked = true;
    addresses.find((a) => a.name === 'unsolicited.in')!.checked = true;
  }
  if (serviceType === TRUSTED_CFS) {
    addresses.find((a) => a.name === 'out')!.checked = true;
    addresses.find((a) => a.name === 'response.in')!.checked = true;
    addresses.find((a) => a.name === 'unsolicited.in')!.checked = true;
  }
  return addresses;
}
